import { render, staticRenderFns } from "./RabbitTransfer.vue?vue&type=template&id=001c73d5&"
import script from "./RabbitTransfer.vue?vue&type=script&lang=js&"
export * from "./RabbitTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports